import request from '@/utils/request'

let IndexApi = {

  /*基础配置*/
  base(data, errorback) {
    return request._post('/shop/index/base', data, errorback);
  },

  /*商城首页*/
  getCount(data, errorback) {
    return request._post('/shop/Index/index', data, errorback);
  },
  /*商城首页*/
  dataCenter(data, errorback) {
    return request._post('/shop/Index/dataCenter', data, errorback);
  },
  dataCenter2(data, errorback) {
    return request._post('/shop/Index/dataCenter2', data, errorback);
  },
  dataCenter3(data, errorback) {
    return request._post('/shop/Index/dataCenter3', data, errorback);
  },
  dataCenter4(data, errorback) {
    return request._post('/shop/Index/dataCenter4', data, errorback);
  },
  dataCenter5(data, errorback) {
    return request._post('/shop/Index/dataCenter5', data, errorback);
  },
  dataCenter6(data, errorback) {
    return request._post('/shop/Index/dataCenter6', data, errorback);
  },
  dataCenter7(data, errorback) {
    return request._post('/shop/Index/dataCenter7', data, errorback);
  },


  /*获取消息列表*/
  getNewList(data, errorback) {
    return request._post('/shop/index/getNewList', data, errorback);
  },
  /*一键已读*/
  readAll(data, errorback) {
    return request._post('/shop/index/updateNewsStatus', data, errorback);
  }
}

export default IndexApi;



// WEBPACK FOOTER //
// ./src/api/index.js